export const CART_ADD = "CART_ADD";
export const CART_REMOVE = "CART_REMOVE";

export const TOGGLE_LISTENING = "TOGGLE_LISTENING";

export const BANNER_CART_ADD = "BANNER_CART_ADD";
export const BANNER_CART_REMOVE = "BANNER_CART_REMOVE";